import React from "react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { useI18n } from "@/context/i18n";
import { formatPrice } from "@/utils/monetary-formatter";

export interface IProductsModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  planData: {
    name: string;
    products?: Array<{
      id: string;
      name: string;
      type: string;
      capital_value: number;
      premium_value: number;
      description: string;
    }>;
  } | null;
}

export const ProductsModal: React.FC<IProductsModalProps> = ({
  open,
  onOpenChange,
  planData,
}) => {
  const { t } = useI18n();

  if (!planData) return null;

  // Verificar se products existe e tem dados
  if (!planData.products || planData.products.length === 0) {
    return (
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="!w-[90vw] !max-w-none max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>Produtos do Plano - {planData.name}</DialogTitle>
          </DialogHeader>
          <div className="text-center text-gray-500 py-8">
            Nenhum produto encontrado neste plano.
          </div>
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="!w-[90vw] !max-w-none max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center justify-between">
            <span>Produtos do Plano - {planData.name}</span>
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-6">
          {/* Resumo */}
          <div className="flex items-center justify-between">
            <div className="text-sm text-muted-foreground">
              Total de produtos:{" "}
              <span className="font-medium">{planData.products.length}</span>
            </div>
          </div>

          {/* Tabela de Produtos */}
          {planData.products.length > 0 ? (
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Nome do Produto</TableHead>
                  <TableHead>Tipo</TableHead>
                  <TableHead>Valor do Capital</TableHead>
                  <TableHead>Valor do Prêmio</TableHead>
                  <TableHead>Descrição</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {planData.products.map((product) => (
                  <TableRow key={product.id}>
                    <TableCell className="font-medium">
                      {product.name}
                    </TableCell>
                    <TableCell>{t(`product.type.${product.type}`)}</TableCell>
                    <TableCell>
                      {product.capital_value > 0
                        ? formatPrice(product.capital_value)
                        : "N/A"}
                    </TableCell>
                    <TableCell>{formatPrice(product.premium_value)}</TableCell>
                    <TableCell>
                      {product.description || "Sem descrição"}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          ) : (
            <div className="text-center text-gray-500 py-8">
              Nenhum produto encontrado neste plano.
            </div>
          )}

          {/* Botão Fechar */}
          <div className="flex justify-end">
            <Button onClick={() => onOpenChange(false)}>Fechar</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
